function TabHeaderCtrl() {
  this.selected = {};
  this.isRender = true;
}
;
export default TabHeaderCtrl;